import axiosInstance from './api';

const bookCallService = {
    bookCall(data) {
        return axiosInstance.post('/book-call', data).catch(console.error);
    },
};

export default bookCallService;
